(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["elare-homepage"] && !Shopify.designMode) return;
  try {
    
  const initializeElareCollectionCarousels = (scope = document) => {
    scope.querySelectorAll('[data-elare-collection-carousel]').forEach((carousel) => {
      if (carousel.dataset.carouselReady === 'true') return;

      const slides = Array.from(carousel.querySelectorAll('[data-elare-collection-slide]'));
      const collectionSplit = carousel.closest('.elare-split');
      const collectionList = collectionSplit?.querySelector('.elare-collection-list');
      const triggers = collectionSplit
        ? Array.from(collectionSplit.querySelectorAll('[data-elare-collection-trigger]'))
        : [];
      if (slides.length === 0) return;

      carousel.dataset.carouselReady = 'true';

      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      let activeIndex = 0;
      let timer;

      const showSlide = (nextIndex) => {
        activeIndex = (nextIndex + slides.length) % slides.length;

        slides.forEach((slide, index) => {
          const isActive = index === activeIndex;
          slide.classList.toggle('is-active', isActive);
          slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
          slide.inert = !isActive;
        });
      };

      const stop = () => {
        window.clearInterval(timer);
      };

      const start = () => {
        stop();
        const interactionPaused =
          carousel.matches(':hover') ||
          carousel.matches(':focus-within') ||
          collectionList?.matches(':hover') ||
          collectionList?.matches(':focus-within');

        if (!reducedMotion && !document.hidden && !interactionPaused && slides.length > 1) {
          timer = window.setInterval(() => {
            showSlide(activeIndex + 1);
          }, 6000);
        }
      };

      const showTriggeredSlide = (trigger) => {
        const triggerIndex = Number.parseInt(trigger.dataset.elareCollectionIndex, 10);
        if (!Number.isNaN(triggerIndex)) {
          showSlide(triggerIndex);
        }
      };

      const handleVisibilityChange = () => {
        if (document.hidden) {
          stop();
        } else {
          start();
        }
      };

      carousel.addEventListener('mouseenter', stop);
      carousel.addEventListener('mouseleave', start);
      carousel.addEventListener('focusin', stop);
      carousel.addEventListener('focusout', (event) => {
        if (!carousel.contains(event.relatedTarget)) start();
      });

      triggers.forEach((trigger) => {
        trigger.addEventListener('mouseenter', () => {
          stop();
          showTriggeredSlide(trigger);
        });
        trigger.addEventListener('focusin', () => {
          stop();
          showTriggeredSlide(trigger);
        });
      });

      if (collectionList) {
        collectionList.addEventListener('mouseleave', start);
        collectionList.addEventListener('focusout', (event) => {
          if (!collectionList.contains(event.relatedTarget)) start();
        });
      }

      document.addEventListener('visibilitychange', handleVisibilityChange);

      showSlide(0);
      start();

      carousel.elareCollectionCarouselStop = () => {
        stop();
        document.removeEventListener('visibilitychange', handleVisibilityChange);
      };
    });
  };

  const initializeElareNewArrivals = (scope = document) => {
    scope.querySelectorAll('[data-elare-new-arrivals]').forEach((section) => {
      if (section.dataset.carouselReady === 'true') return;

      const viewport = section.querySelector('[data-new-arrivals-viewport]');
      const track = section.querySelector('[data-new-arrivals-track]');
      const items = Array.from(section.querySelectorAll('[data-new-arrivals-item]'));
      const status = section.querySelector('[data-new-arrivals-status]');
      const range = section.querySelector('[data-new-arrivals-range]');
      const previous = section.querySelector('[data-new-arrivals-previous]');
      const next = section.querySelector('[data-new-arrivals-next]');

      if (!viewport || !track || items.length === 0) return;

      section.dataset.carouselReady = 'true';

      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      let activeIndex = 0;
      let timer;
      let resizeObserver;

      const visibleCount = () => {
        if (window.matchMedia('(max-width: 640px)').matches) return 2;
        if (window.matchMedia('(max-width: 990px)').matches) return 3;
        return 5;
      };

      const maximumIndex = () => Math.max(0, items.length - visibleCount());

      const stop = () => {
        window.clearInterval(timer);
      };

      const updateStatus = () => {
        const visible = Math.min(visibleCount(), items.length);
        const first = activeIndex + 1;
        const last = Math.min(activeIndex + visible, items.length);
        const rotating = maximumIndex() > 0;

        items.forEach((item, index) => {
          item.inert = index < activeIndex || index >= activeIndex + visible;
        });

        if (range) {
          range.textContent = `${String(first).padStart(2, '0')} - ${String(last).padStart(2, '0')}`;
        }

        if (status) {
          status.hidden = !rotating;
        }
      };

      const setPosition = (nextIndex, animate = true) => {
        activeIndex = Math.min(Math.max(0, nextIndex), maximumIndex());
        const firstItem = items[0];
        const gap = Number.parseFloat(window.getComputedStyle(track).columnGap) || 0;
        const step = firstItem.getBoundingClientRect().width + gap;

        if (!animate) {
          track.style.transition = 'none';
        }

        track.style.transform = `translate3d(-${activeIndex * step}px, 0, 0)`;
        updateStatus();

        if (!animate) {
          window.requestAnimationFrame(() => {
            track.style.transition = '';
          });
        }
      };

      const advance = () => {
        if (activeIndex >= maximumIndex()) {
          setPosition(0, false);
        } else {
          setPosition(activeIndex + 1);
        }
      };

      const retreat = () => {
        if (activeIndex <= 0) {
          setPosition(maximumIndex(), false);
        } else {
          setPosition(activeIndex - 1);
        }
      };

      const start = () => {
        stop();
        const interactionPaused = section.matches(':hover') || section.matches(':focus-within');

        if (!reducedMotion && !document.hidden && !interactionPaused && maximumIndex() > 0) {
          timer = window.setInterval(advance, 6000);
        }
      };

      if (previous) {
        previous.addEventListener('click', () => {
          retreat();
          start();
        });
      }

      if (next) {
        next.addEventListener('click', () => {
          advance();
          start();
        });
      }

      section.addEventListener('mouseenter', stop);
      section.addEventListener('mouseleave', start);
      section.addEventListener('focusin', stop);
      section.addEventListener('focusout', (event) => {
        if (!section.contains(event.relatedTarget)) start();
      });

      document.addEventListener('visibilitychange', () => {
        if (document.hidden) {
          stop();
        } else {
          start();
        }
      });

      resizeObserver = new ResizeObserver(() => {
        setPosition(Math.min(activeIndex, maximumIndex()), false);
        start();
      });
      resizeObserver.observe(viewport);

      setPosition(0, false);
      start();

      section.elareNewArrivalsStop = () => {
        stop();
        resizeObserver.disconnect();
      };
    });
  };

  initializeElareCollectionCarousels();
  initializeElareNewArrivals();

  document.addEventListener('shopify:section:load', (event) => {
    initializeElareCollectionCarousels(event.target);
    initializeElareNewArrivals(event.target);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-elare-collection-carousel]').forEach((carousel) => {
      if (carousel.elareCollectionCarouselStop) {
        carousel.elareCollectionCarouselStop();
      }
    });

    const section = event.target.querySelector('[data-elare-new-arrivals]');
    if (section && section.elareNewArrivalsStop) {
      section.elareNewArrivalsStop();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["elare-refinements"] && !Shopify.designMode) return;
  try {
    
  const elareDesktopMenu = window.matchMedia('(min-width: 990px) and (hover: hover)');

  const closeElareMenu = (details) => {
    details.removeAttribute('open');
    details.querySelector(':scope > summary')?.setAttribute('aria-expanded', 'false');
  };

  document.querySelectorAll('.header__inline-menu header-menu > details').forEach((details) => {
    if (!details.querySelector(':scope > .header__submenu')) return;

    const menu = details.parentElement;
    if (menu.dataset.elareHoverMenu === 'true') return;
    menu.dataset.elareHoverMenu = 'true';

    menu.addEventListener('mouseenter', () => {
      if (!elareDesktopMenu.matches) return;
      details.setAttribute('open', '');
      details.querySelector(':scope > summary')?.setAttribute('aria-expanded', 'true');
    });

    menu.addEventListener('mouseleave', () => {
      if (!elareDesktopMenu.matches) return;
      closeElareMenu(details);
    });

    menu.addEventListener('focusin', () => {
      if (!elareDesktopMenu.matches) return;
      details.setAttribute('open', '');
      details.querySelector(':scope > summary')?.setAttribute('aria-expanded', 'true');
    });

    menu.addEventListener('focusout', () => {
      if (!elareDesktopMenu.matches) return;
      requestAnimationFrame(() => {
        if (!menu.contains(document.activeElement)) closeElareMenu(details);
      });
    });
  });

  elareDesktopMenu.addEventListener('change', (event) => {
    if (event.matches) return;
    document.querySelectorAll('.header__inline-menu header-menu > details[open]').forEach(closeElareMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
